export const UserArrangeFormWrapper = {
  padding: 0,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  textAlign: 'left',
}
